module.exports = __webpack_public_path__ + "static/progressbar-ca167c50e6fb4a21ec955cf95096cbd6.png";